"use client";

import { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "../utils/api";
import { logout } from "../utils/logout";

export const AuthContext = createContext({});

export const AuthContextProvider = ({ children }) => {

    const privatePages = useMemo(() => ["/dash", "/account", "/billets", "/receivers"], []);
    
    const [userInfos, setUserInfos] = useState([]);
    const [receiversOptions, setReceiversOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(typeof window !== "undefined" ? window.location.pathname : "");

    useEffect(() => {
        if (typeof window !== "undefined") {
            const handleUrlChange = () => {
                setCurrentPage(window.location.pathname);
            };

            window.addEventListener('popstate', handleUrlChange);

            return () => {
                window.removeEventListener('popstate', handleUrlChange);
            };
        }
    }, []);

    useEffect(() => {
        if (typeof window !== "undefined" && !userInfos?.name && privatePages.includes(currentPage)) {

            setIsLoading(true);

            api.get('/auth/me', {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })
            .then(function (res) {
                setUserInfos(res.data.auth);
                let receiversOptionsBd = [{
                    'label': '',
                    'value': ''
                }];
                res.data.receivers.forEach(value => {
                    receiversOptionsBd.push({
                        'label': value.name,
                        'value': value.id,
                        'type': value.type,
                    });
                })
                setReceiversOptions(receiversOptionsBd);
                setIsLoading(false);
            })
            .catch(err => {
                setIsLoading(false);
                logout();
            });
            
        }
    }, [userInfos?.name, currentPage, localStorage.getItem('token')]);

    return(
        <AuthContext.Provider 
            value={{
                userInfos,
                setUserInfos,
                isLoading,
                setIsLoading,
                receiversOptions,
                setReceiversOptions
            }}
        >
            {children}
        </AuthContext.Provider>
    )
}

export const useAuthContext = () => useContext(AuthContext);
